import { useTranslation } from "react-i18next"
import img1 from './../../../assets/images/img1-med.jpeg'
import img2 from './../../../assets/images/img2-med.jpeg'

export default function HomeAbout() {
	const { t } = useTranslation()
  return (
    <>
      {/* <!--About Us Start--> */}
			<div className="ast_about_wrapper gray_wrapper ast_toppadder70 ast_bottompadder70">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 col-md-12 col-sm-12 col-12">
							<div className="ast_about_info_img">
								<div className="about_slider slider_half">
									<div className="card c" id="first"><img src={img1} alt="" className="img-responsive"/></div>
									<div className="card a" id="second"><img src={img2} alt="" className="img-responsive"/></div>

									<div className="btn-wrap">
										<a href="javascript:void(0);" className="btn focus" id="one"></a>
										<a href="javascript:void(0);" className="btn" id="two"></a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-6 col-md-12 col-sm-12 col-12">
							<div className="ast_about_info">
								<h4>{t('home_view.about_tarot_title')}</h4>
								<p>{t('home_view.about_tarot_paragraph_1')}</p>
								<p>{t('home_view.about_tarot_paragraph_2')}</p>
								<p>{t('home_view.about_tarot_paragraph_3')}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <!--About Us End--> */}
    </>
  ) 
}